<template>
  <VModal ref="modal" @modal:hidden="$emit('closed')">
    <BaseCard @click.stop class="max-w-screen-md w-full mx-auto">
      <BaseCardHeader>
        <div class="flex">
          <div class="flex-1">
            {{ product.name }}
          </div>
          <div class="flex-none">
            <button
              type="button"
              class="bg-white rounded-full text-gray-400 hover:text-gray-500 p-1 -mr-1 focus:outline-none focus:bg-gray-100"
              @click="$refs.modal.close()"
            >
              <span class="sr-only">Close</span>
              <!-- Heroicon name: outline/x -->
              <svg
                class="h-6 w-6"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
        </div>
      </BaseCardHeader>
      <BaseCardBody class="p-4 lg:p-8">
        <div v-html="content" class="prose" />
      </BaseCardBody>
    </BaseCard>
  </VModal>
</template>

<script>
import { marked } from 'marked';
import VModal from '../Common/VModal.vue';

export default {
  components: { VModal },
  props: {
    productId: {
      type: String,
      required: true,
    },
  },
  computed: {
    product() {
      return this.$store.state.entities.products.byId[this.productId];
    },
    content() {
      return marked(this.product?.requirements || '');
    },
  },
  created() {
    this.fetchProduct();
  },
  methods: {
    async fetchProduct() {
      this.loading = true;

      try {
        await this.$store.dispatch('ui/products/fetchProduct', {
          productId: this.productId,
        });

        this.resolved = true;
      } catch (error) {
        this.rejected = true;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
